export default __webpack_public_path__ + "static/media/illustration-study-1-n-m@2x.4655db87.webp";